import { Route } from 'react-router-dom'
import { lazyWithRetry as lazy } from '../lib/lazyWithRetry'

// EVT (Events) — cabinet portal: CREATE + ADMINISTER events. List + lifecycle,
// per-event management (speakers/sessions/tickets/promos/registrations), QR
// check-in, and post-event analytics. Spread into the app-wide <Routes> (inside
// the MainLayout group, BEFORE the catch-all) — same pattern as aiExpertsRoutes.
const EventsAdminPage = lazy(() =>
  import('../pages/events/EventsAdminPage').then((m) => ({ default: m.EventsAdminPage })),
)
const EventManagePage = lazy(() =>
  import('../pages/events/EventManagePage').then((m) => ({ default: m.EventManagePage })),
)
const EventCheckinPage = lazy(() =>
  import('../pages/events/EventCheckinPage').then((m) => ({ default: m.EventCheckinPage })),
)
const EventAnalyticsPage = lazy(() =>
  import('../pages/events/EventAnalyticsPage').then((m) => ({ default: m.EventAnalyticsPage })),
)

export const eventsRoutes = [
  <Route key="events" path="/events" element={<EventsAdminPage />} />,
  <Route key="events-checkin" path="/events/:eventId/checkin" element={<EventCheckinPage />} />,
  <Route key="events-analytics" path="/events/:eventId/analytics" element={<EventAnalyticsPage />} />,
  <Route key="events-manage" path="/events/:eventId" element={<EventManagePage />} />,
]
